import PropTypes            from 'prop-types';
import { connect }          from 'react-redux';
import {
  compose,
  setDisplayName,
  wrapDisplayName
}                           from 'recompose';
import { selectInEditMode } from '../selectors/editableContentSelectors';


export const PROP_IN_EDIT_MODE = 'inEditMode';


const displayName = 'MapInEditMode';


/**
 * Maps the 'inEditMode' prop to indicate whether in editing mode.
 *
 * @param {?function} innerComponent Inner component.  If provided, is used to create the display name.
 *
 * @return {function(*=): *}
 */
const mapInEditMode = ({innerComponent} = {}) => (Component) => compose(
  setDisplayName((innerComponent && wrapDisplayName(innerComponent, displayName)) || displayName),
  connect(
    state => ({
      [PROP_IN_EDIT_MODE]: selectInEditMode(state)
    }),
    {}
  ),
)(Component);


export const MapInEditModePropTypes = {

  // Flag to indicate whether user is currently editing.
  [PROP_IN_EDIT_MODE]: PropTypes.bool,

};


export default mapInEditMode;


// WEBPACK FOOTER //
// ./src/modules/editableContent/components/mapInEditMode.js